import { createContext, useContext } from 'react';

import { EMPTY_FUNCTION } from '../../../constants';
import { InputContextProps } from '../types';

export const InputContext = createContext<InputContextProps>({
  inputRef: null,
  placeholder: '',
  auto_focus: false,
  text_align: 'right',
  value: '',
  typed_value: '',
  disabled: false,
  error: false,
  onChange: EMPTY_FUNCTION,
  onKeyDown: EMPTY_FUNCTION,
  onFocus: EMPTY_FUNCTION,
  onBlur: EMPTY_FUNCTION,
  onRemove: EMPTY_FUNCTION,
});

export const useInputContext = () => useContext(InputContext) as InputContextProps;
